module.exports = __webpack_public_path__ + "static/media/confirmation-modal-footer.ef5a909a.png";